// extracted by mini-css-extract-plugin
export default {"holder":"Portfolio_holder__lguc0","linkHolder":"Portfolio_linkHolder__SpBw4"};